import { IMPERSONATION_ACTION_TYPES, USER_LOGOUT } from '../actions/reduxConstants';

export interface ImpersonationState {
	isImpersonated: boolean;
	impersonatedBy: string | null;
	impersonationSessionId: string | null;
	adminPortalUrl: string | null;
}

const INITIAL_STATE: ImpersonationState = {
	isImpersonated: false,
	impersonatedBy: null,
	impersonationSessionId: null,
	adminPortalUrl: null,
};

interface SetImpersonationAction {
	type: typeof IMPERSONATION_ACTION_TYPES.SET_IMPERSONATION;
	payload: {
		impersonatedBy: string;
		impersonationSessionId: string;
		adminPortalUrl?: string;
	};
}

interface ClearImpersonationAction {
	type: typeof IMPERSONATION_ACTION_TYPES.CLEAR_IMPERSONATION;
}

interface UserLogoutAction {
	type: typeof USER_LOGOUT;
}

type ImpersonationAction = SetImpersonationAction | ClearImpersonationAction | UserLogoutAction;

const impersonation_reducer = (state: ImpersonationState = INITIAL_STATE, action: ImpersonationAction): ImpersonationState => {
	switch (action.type) {
		case IMPERSONATION_ACTION_TYPES.SET_IMPERSONATION:
			return {
				...state,
				isImpersonated: true,
				impersonatedBy: action.payload.impersonatedBy,
				impersonationSessionId: action.payload.impersonationSessionId,
				adminPortalUrl: action.payload.adminPortalUrl || null,
			};
		case IMPERSONATION_ACTION_TYPES.CLEAR_IMPERSONATION:
		case USER_LOGOUT:
			return INITIAL_STATE;
		default:
			return state;
	}
};

export default impersonation_reducer;
